import React, { useEffect, useRef, useState } from 'react';

const PIN = (process.env.REACT_APP_PIN || '123456').padEnd(6, '0').slice(0, 6);

export default function PinLock({ onUnlock }) {
  const [digits, setDigits] = useState('');
  const [wrong, setWrong] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (digits.length !== 6) return;
    if (digits === PIN) {
      onUnlock();
    } else {
      setWrong(true);
      setTimeout(() => {
        setWrong(false);
        setDigits('');
        inputRef.current?.focus();
      }, 550);
    }
  }, [digits, onUnlock]);

  const onChange = (e) => {
    const v = e.target.value.replace(/\D/g, '').slice(0, 6);
    setDigits(v);
  };

  const tap = (n) => {
    if (digits.length >= 6) return;
    setDigits((d) => (d + String(n)).slice(0, 6));
    inputRef.current?.focus();
  };

  const back = () => setDigits((d) => d.slice(0, -1));

  return (
    <div className="pinlock">
      <div className={`pinlock-card ${wrong ? 'wrong' : ''}`}>
        <div className="pinlock-lock">🔒</div>
        <div className="pinlock-title">Enter PIN</div>
        <div className="pinlock-sub">6-digit passcode to access Aina</div>

        <div className="pin-boxes" onClick={() => inputRef.current?.focus()}>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className={`pin-box ${digits[i] ? 'filled' : ''}`}>
              {digits[i] ? '•' : ''}
            </div>
          ))}
        </div>

        {/* Hidden input catches keyboard/paste */}
        <input
          ref={inputRef}
          type="tel"
          inputMode="numeric"
          autoComplete="one-time-code"
          value={digits}
          onChange={onChange}
          className="pin-hidden-input"
        />

        <div className="pin-pad">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
            <button key={n} className="pin-key" onClick={() => tap(n)}>
              {n}
            </button>
          ))}
          <button className="pin-key ghost" disabled />
          <button className="pin-key" onClick={() => tap(0)}>0</button>
          <button className="pin-key back" onClick={back} title="Delete">⌫</button>
        </div>
      </div>
    </div>
  );
}
